import React from "react";
import Portfolio2 from "../Portfolio/Portfolio2";

function MissionAndGoals() {
  return (
    <>
      <style>{`
        /* 🔶 TOP HEADER (outside black section) */
        .top-header {
  text-align: center;
  padding: 50px 0;   /* 🔥 more space top & bottom */
  background: linear-gradient(to right, #ffdb5e, #ffffff);
}

.top-title {
  font-size: 48px;   /* 🔥 bigger text */
  font-weight: 900;  /* extra bold */
  color: #c73b18;
  margin: 0;
  letter-spacing: 1px;
}

        /* 🔶 GRADIENT BACKGROUND WRAPPER */
.divider-section {
  background: linear-gradient(to right, #ffdb5e, #ffffff);
  padding: 40px 0;
}

.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
      `}</style>

      {/* ✅ OUTSIDE HEADER */}
      <div className="top-header">
        <h1 className="top-title">Mission & Goals</h1>
        <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div>
      </div>
        
      <Portfolio2 />
    </>
  );
}

export default MissionAndGoals;
